import { buildProps, definePropType } from '@ll-plus/utils'

import { SizeType } from 'ant-design-vue/es/config-provider'
import type { ExtractPropTypes } from 'vue'
import type IconPicker from '../icon-picker.vue'

export interface IconPickerItem {
  icon_id?: string
  name?: string
  font_class?: string
  unicode?: string
  unicode_decimal?: number
}

export const iconPickerProps = buildProps({
  // buildProps和defineprops一样
  /**
   * @description 选中的icon
   */
  value: {
    type: String,
  },
  /**
   * @description 模态框的icon列表
   */
  iconList: {
    type: definePropType<IconPickerItem[]>(Array),
  },

  // 是否只读，默认只读
  readonly: {
    type: Boolean,
    default: true,
  },

  // 尺寸
  size: {
    type: String as () => SizeType,
  },

  // 继承尺寸(服务设计器)
  extendSize: {
    type: String as () => SizeType,
  },

  // 只显示图标
  showIconOnly: {
    type: Boolean,
    default: false,
  },
} as const)

// props
export type IconPickerProps = ExtractPropTypes<typeof iconPickerProps> // ExtractPropTypes和defineCpmponent类似

// instance
export type IconPickerInstance = InstanceType<typeof IconPicker>
